module.exports = __webpack_public_path__ + "img/color-1_en.5242d32.jpg";